import {addErrorMessage} from './feedback';
import {MergeAction, createMergeAction} from './base';
import {V2Resource} from './services';
import {TEXT_ERROR_ALARM_COUNT} from './locale';

/**
 * Returns the state that enables alarm count load
 */
function enableAlarmLoad() : MergeAction {
    return createMergeAction(
        'alarm_load',
        {ui: {summary: {alarms: {uncleared_count: {loading: true}}}}}
    );
}

/**
 * Merge: enables alarm count load
 */
function disableAlarmLoad() : MergeAction {
    return createMergeAction(
        'alarm_load',
        {ui: {summary: {alarms: {uncleared_count: {loading: false}}}}}
    );
}

/**
 * Merge: new uncleared alarm count
 */
function setUnclearedAlarmCount(newCount: number) : MergeAction {
    return createMergeAction(
        'set_alarm_count',
        {data: {summary: {alarms: {uncleared_count: newCount}}}}
    );
}


/**
 * Thunk: loads the latest alarm count
 */
export function updateUnclearedAlarmCount() : Function {
    return function (dispatch) {
        dispatch(enableAlarmLoad());
        let resource = new V2Resource(V2Resource.ALARM);
        return resource.count({cleared: false}).then(function(response) {
            dispatch(setUnclearedAlarmCount(response.data.count));
            dispatch(disableAlarmLoad());
        }).catch(function() {
            dispatch(addErrorMessage(TEXT_ERROR_ALARM_COUNT));
            dispatch(disableAlarmLoad());
        });
    }
};